interface LogoProps {
  variant?: 'primary' | 'compact' | 'light' | 'mono';
  size?: number;
  wordSize?: number;
  className?: string;
}

const BRAND_BLUE = '#0B7BFD';
const BRAND_BLUE_LIGHT = '#3D9BFF';
const BRAND_WHITE = '#FFFFFF';

export function LogoMark({ variant = 'primary', size = 40, className }: LogoProps): JSX.Element {
  return (
    <img
      src="/brand/logo-mark.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={className}
      style={{
        width: size,
        height: size,
        display: 'block',
        objectFit: 'contain',
        filter: variant === 'light' ? 'drop-shadow(0 1px 2px rgba(0,0,0,.35))' : undefined
      }}
    />
  );
}

export function Logo({ variant = 'primary', size = 36, wordSize, className }: LogoProps): JSX.Element {
  const wordColor = variant === 'light' ? BRAND_WHITE : variant === 'mono' ? 'currentColor' : 'var(--nl-text)';
  const proColor = variant === 'mono' ? 'currentColor' : variant === 'light' ? BRAND_BLUE_LIGHT : BRAND_BLUE;
  return (
    <span className={`inline-flex items-center gap-2.5 ${className ?? ''}`}>
      <LogoMark variant={variant} size={size} />
      <span
        style={{ color: wordColor, fontSize: wordSize ?? size * 0.6, lineHeight: 1 }}
        className="font-display font-bold tracking-[-0.02em] whitespace-nowrap"
      >
        <span className="sr-only">Agenda Pro</span>
        <span aria-hidden="true">Agenda</span>
        <span aria-hidden="true" style={{ color: proColor }}> Pro</span>
      </span>
    </span>
  );
}
